import DestroyArchive from "./DestroyArchive";

export default DestroyArchive;
